module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "app.rephrase.twolineslist.title.tester": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tester cette reformulation"])},
        "app.rephrase.twolineslist.title.tip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(ne prend pas en compte les changements non sauvegardés)"])}
      },
      "en": {
        "app.rephrase.twolineslist.title.tester": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Try this rephrasing"])},
        "app.rephrase.twolineslist.title.tip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(does not take into account unsaved changes)"])}
      },
      "es": {
        "app.rephrase.twolineslist.title.tester": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Probar esta reformulación"])},
        "app.rephrase.twolineslist.title.tip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(no tiene en cuenta los cambios no guardados)"])}
      }
    }
  })
  Component.options.__i18nBridge = Component.options.__i18nBridge || []
  Component.options.__i18nBridge.push('{"fr":{"app.rephrase.twolineslist.title.tester":"Tester cette reformulation","app.rephrase.twolineslist.title.tip":"(ne prend pas en compte les changements non sauvegardés)"},"en":{"app.rephrase.twolineslist.title.tester":"Try this rephrasing","app.rephrase.twolineslist.title.tip":"(does not take into account unsaved changes)"},"es":{"app.rephrase.twolineslist.title.tester":"Probar esta reformulación","app.rephrase.twolineslist.title.tip":"(no tiene en cuenta los cambios no guardados)"}}')
  delete Component.options._Ctor
  
}
